import clsx from 'clsx'
import React, { FunctionComponent, ReactNode } from 'react'

import styles from './style.module.scss'

export interface RadioFooterProps {
  children: ReactNode
  sticky?: boolean
  testNameSpace?: string
}

export const RadioFooter: FunctionComponent<RadioFooterProps> = ({ children, sticky = false, testNameSpace = '' }) => {
  const footerClassName = clsx(styles.footer, sticky && styles.sticky)

  return (
    <div className={footerClassName} {...(testNameSpace.length > 0 && { 'data-testid': `${testNameSpace}-radio-footer` })}>
      {children}
    </div>
  )
}
